import type { RouteConfig } from 'vue-router';

/**
 * API导流类路由
 */
export default [
  /**
   * 个人信息页
   */
  {
    path: '/partner/information',
    meta: {
      title: '个人信息',
    },
    component: () => import('@/views/partner/information.vue'),
  },
  /**
   * 审核中
   */
  {
    path: '/partner/assessment',
    meta: {
      title: '资金匹配',
      background: '#fff',
    },
    component: () => import('@/views/partner/assessment.vue'),
  },
  /**
   * 借款申请页
   */
  {
    path: '/partner/loan/apply',
    meta: {
      title: '提现申请',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan/apply.vue'),
  },
  /**
   * 借款确认页
   */
  {
    path: '/partner/loan',
    meta: {
      title: '借款',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan/index.vue'),
  },
  /**
   * 提现申请信息补充页
   */
  {
    path: '/partner/loan/apply-complete',
    meta: {
      title: '提现页',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan/apply-complete.vue'),
  },
  /**
   * 银行卡列表
   */
  {
    path: '/partner/bankcard',
    meta: {
      title: '银行卡列表',
    },
    component: () => import('@/views/partner/bankcard/index.vue'),
  },
  /**
   * 添加银行卡
   */
  {
    path: '/partner/bankcard/add',
    meta: {
      title: '添加银行卡',
    },
    component: () => import('@/views/partner/bankcard/add.vue'),
  },
  /**
   * 添加银行卡-短信验证
   */
  {
    path: '/partner/bankcard/:cardId/verify',
    meta: {
      title: '验证',
    },
    component: () => import('@/views/partner/bankcard/verify.vue'),
  },
  /**
   * 借款协议
   */
  {
    path: '/partner/loan/agreement',
    meta: {
      title: '借款协议',
      background: '#fff',
    },
    component: () => import('@/views/partner/loan/agreement.vue'),
  },
  /**
   * 放款结果
   */
  {
    path: '/partner/loan/result',
    meta: {
      title: '放款结果',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan/result.vue'),
  },
  /**
   * 车抵贷
   */
  {
    path: '/partner/car-loan',
    meta: {
      title: '车抵贷',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan/index.vue'),
  },
  /**
   * 车抵贷
   */
  {
    path: '/partner/car-loan/record',
    meta: {
      title: '车抵贷',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan/record.vue'),
  },

  /**
   * 车抵贷(新)
   */
  {
    path: '/partner/car-loan-new',
    meta: {
      title: '车抵贷',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan-new/index.vue'),
  },

  /**
   * 车抵贷ocr(新)
   */
  {
    path: '/partner/car-loan-new/identity-card',
    meta: {
      title: '身份认证',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan-new/identity-card.vue'),
  },

  /**
   * 车抵贷(新)
   */
  {
    path: '/partner/car-loan-new/assessment',
    meta: {
      title: '审核结果',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan-new/assessment.vue'),
  },
  /**
   * 车抵贷记录(新)
   */
  {
    path: '/partner/car-loan-new/record',
    meta: {
      title: '申请记录',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan-new/record.vue'),
  },
  /**
   * 车抵贷审核结果页(新)
   */
  {
    path: '/partner/car-loan-new/result',
    meta: {
      title: '审核结果页',
      background: '#F2F4F7',
      customNavBar: true,
    },
    component: () => import('@/views/partner/car-loan-new/result.vue'),
  },
  /**
   * 首页卡片广告主提额
   */
  {
    path: '/partner/credit-limit',
    meta: {
      title: '提额',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/credit-limit/index.vue'),
  },
  /**
   * 首页卡片广告主提额结果页
   */
  {
    path: '/partner/credit-limit/result',
    meta: {
      title: '提额结果',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/credit-limit/result.vue'),
  },
  /**
   * 芝士提现过渡页
   */
  {
    path: '/partner/transition-page',
    meta: {
      title: '提现页',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/transition-page/index.vue'),
  },
  /**
   * 提额中心广告主提额
   */
  {
    path: '/partner/increase-credit-limit',
    meta: {
      title: '提额',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/increase-credit-limit/index.vue'),
  },
  /**
   * 提额中心提额结果
   */
  {
    path: '/partner/increase-credit-limit/result',
    meta: {
      title: '提额',
      background: '#F0F3FD',
      customNavBar: true,
    },
    component: () => import('@/views/partner/increase-credit-limit/result.vue'),
  },
  /**
   * 轻资产回调页
   */
  {
    path: '/partner/loan/waiting',
    meta: {
      title: '匹配资金',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan/waiting.vue'),
  },

  /**
   * 提额中心跳广告主的中转页
   */
  {
    path: '/partner/relay',
    meta: {
      title: '提额',
      customNavBar: true,
    },
    component: () => import('@/views/partner/relay.vue'),
  },

  /**
   * 提额中心跳转 个人信息页引导填写
   */
  {
    path: '/partner/person-complete-guide',
    meta: {
      title: '提额',
      customNavBar: true,
    },
    component: () => import('@/views/partner/person-complete-guide.vue'),
  },

  /**
   * 提额中心跳广告主的中转页
   */
  {
    path: '/partner/loan-guide',
    meta: {
      title: '机构专享借款通道',
      customNavBar: true,
    },
    component: () => import('@/views/partner/loan-guide.vue'),
  },

  /**
   * 借款确认页
   */
  {
    path: '/partner/loan/queue',
    meta: {
      title: '借款结果',
      customNavBar: true,
      background: '#fff',
    },
    component: () => import('@/views/partner/loan/queue.vue'),
  },
] as RouteConfig[];
